export default __webpack_public_path__ + "static/media/Background_00140.b6c760e5.png";